// extracted by mini-css-extract-plugin
export default {"details":"TCXYn2xOOB","details-code":"f4CzLMaizp","detailsCode":"f4CzLMaizp","details-button":"EHGTvHgiEk","detailsButton":"EHGTvHgiEk"};